import { MEETING_LOCATIONS, APP_EVENT_ID } from "../utils/consts";

export const logAction = () => {
  if (window.logaction) {
    window.logaction(MEETING_LOCATIONS.DELEGATE_LOUNGE, APP_EVENT_ID);
  }
};
